import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import Stack from "@mui/material/Stack";
import * as React from "react";
import { IMaskInput } from "react-imask";

interface IMaskInputProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  value?: string;
}

const NumberMaskInput = React.forwardRef<HTMLInputElement, IMaskInputProps>(
  (props, ref) => {
    const { onChange, ...other } = props;
    //integer
    return (
      <IMaskInput
        {...other}
        mask={Number}
        scale={0}
        normalizeZeros={true}
        padFractionalZeros={false}
        inputRef={ref}
        onAccept={(value: string) => {
          onChange({ target: { name: props.name, value } });
        }}
        overwrite
        unmask={false}
      />
    );
  }
);

interface NumberTextFieldProps {
  label?: string;
  name: string;
  value?: string | number;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  helperText?: string;
  required?: boolean;
  readonly?: boolean;
  small?: boolean;
  middle?: boolean;
  endIcon?: React.ReactNode;
  error?: boolean;
  sx?: React.CSSProperties;
}

const NumberTextField = React.forwardRef<
  HTMLInputElement,
  NumberTextFieldProps
>(
  (
    {
      label,
      name,
      value: propValue = "",
      onChange,
      onBlur,
      helperText,
      required = false,
      readonly = false,
      small = false,
      middle = false,
      endIcon = null,
      error: propError = false,
      sx = {},
    },
    ref
  ) => {
    const [internalValue, setInternalValue] = React.useState(
      propValue?.toString() || ""
    );
    const [error, setError] = React.useState(propError);

    // 同步外部value变化
    React.useEffect(() => {
      setInternalValue(propValue?.toString() || "");
    }, [propValue]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = event.target.value;
      setInternalValue(newValue);
      onChange?.(newValue);
    };

    const handleBlur = () => {
      const isValid =
        !required || (internalValue && internalValue.trim() !== "");
      setError(!isValid);
      onBlur?.();
    };

    return (
      <Stack direction="row" spacing={2}>
        <FormControl variant="standard" error={error} fullWidth>
          {label && (
            <InputLabel shrink htmlFor={`number-input-${name}`}>
              {label}
            </InputLabel>
          )}
          <OutlinedInput
            sx={{
              "& input": {
                // padding: "8.5px 14px"
                padding: "12px 14px",
              },
              // readonly
              "& input[readonly]": {
                background: "#eee",
              },
              // width: small ? "100px" : "100%",
              // maxWidth: small ? "100px" : "400px",
              width: small ? "100px" : middle ? "150px" : "100%",
              maxWidth: small ? "100px" : middle ? "150px" : "400px",
              ...sx,
            }}
            readOnly={readonly}
            id={`number-input-${name}`}
            value={internalValue}
            onChange={handleChange}
            onBlur={handleBlur}
            inputComponent={NumberMaskInput as any}
            inputProps={{
              name,
            }}
            endAdornment={endIcon ? endIcon : null}
            inputRef={ref} // 关键修改：正确传递ref
            aria-describedby={`${name}-helper-text`}
          />
          {(error || helperText) && (
            <FormHelperText
              error={error}
              id={`${name}-helper-text`}
              color="error"
              style={{ color: "#d32f2f" }}
            >
              {error ? helperText || "This field is required" : helperText}
            </FormHelperText>
          )}
        </FormControl>
      </Stack>
    );
  }
);

export default NumberTextField;
